import { useCallback } from 'react';
import { useAssistantDispatch, useAssistantSelector, } from '../redux/assistant-hooks';
import { setActiveConversation } from '../redux/assistantConversationSlice';
import { selectActiveConversation } from '../redux/selectors';
export const useConversation = () => {
    const dispatch = useAssistantDispatch();
    const activeConversation = useAssistantSelector(selectActiveConversation);
    const setActive = useCallback((conversationId) => {
        dispatch(setActiveConversation(conversationId));
    }, [dispatch]);
    return {
        activeConversation,
        setActive,
        hasActiveConversation: !!activeConversation,
    };
};
